// Import the functions you need from the SDKs you need
import {initializeApp} from "firebase/app";
import {getAnalytics} from "firebase/analytics";
import {getAuth} from 'firebase/auth'
import {getFirestore} from 'firebase/firestore'
import {getStorage} from 'firebase/storage'
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
// luismrosero1992@gmail.com
const firebaseConfig = {
    apiKey: "AIzaSyDRPhYA020xwwZ1sI5lpYVJuxHTKQXWr3s",
    authDomain: "pet-supplies-3eab9.firebaseapp.com",
    projectId: "pet-supplies-3eab9",
    storageBucket: "pet-supplies-3eab9.firebasestorage.app",
    messagingSenderId: "198843577118",
    appId: "1:198843577118:web:f7510b9650d48cebc94f0f",
    measurementId: "G-TCLXB6KZFV"
};

// Initialize Firebase
export const app = initializeApp(firebaseConfig);
export const analytics = getAnalytics(app);

export const auth = getAuth(app)
export const fire = getFirestore(app)
export const storage = getStorage(app)